import query from 'ismobilejs'

export const isMobile = query(navigator).any
